import {
  addPersonToList,
  addPersonToListFailure,
  addPersonToListSuccess,
  deletePerson,
  deletePersonFailure,
  deletePersonSuccess,
  editPerson,
  editPersonFailure,
  editPersonSuccess,
  getPersonList,
  setPersonList
} from "../actions/personListAction";
import { handleActions } from "redux-actions";

const initState = {
  persons: {
    data: []
  },
  tableLoading: false,
  buttonLoading: false,
  errorMessage: null,
  updated: false
};

const personListReducer = handleActions(
  {
    [getPersonList]: state => {
      return { ...state, tableLoading: true };
    },
    [setPersonList]: (state, { payload: { persons } }) => {
      return { ...state, persons: persons, tableLoading: false, updated: false };
    },
    [addPersonToList]: (state, action) => {
      return { ...state, buttonLoading: true };
    },
    [addPersonToListSuccess]: (state, action) => {
      console.log(action);
      return {
        ...state,
        buttonLoading: false
      };
    },
    [addPersonToListFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, buttonLoading: false };
    },
    [deletePerson]: state => {
      return { ...state, tableLoading: true };
    },
    [deletePersonSuccess]: state => {
      return { ...state, tableLoading: false };
    },
    [deletePersonFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    },
    [editPerson]: state => {
      return { ...state, tableLoading: true };
    },
    [editPersonSuccess]: state => {
      return { ...state, tableLoading: false, updated: true};
    },
    [editPersonFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    }
  },
  initState
);

export default personListReducer;
